// extracted by css-extract-rspack-plugin
export default {"circle":"vdc6rhysAAUrIztc","circleRotate":"yTziyWil_OkWUo1J","check":"AAQdt505xGMwlSGj","checkDraw":"Ztld9FxBShwddslC"};